import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { DialogService } from "../../Shared/dialog.service";

declare var $: any;

interface ProcessRightApiRow {
  BranchId: number;
  Branch_Name: string;
  ProductId: number;
  Product_Name: string;
  ParentId: number;           // requires EPM.Id AS ParentId added to the SP
  From_LoanAmount: number;
  To_LoanAmount: number;
  ProcessId: number;
  Process_Name: string;
  Level: number; 
  IsAllow: number;            // 0 or 1
}

// ---------- View model (pivoted for rendering) ----------
interface SlabCell {
  processId: number;
  processName: string;
   level: number;
  isAllow: boolean;
}

interface SlabRow {
  parentId: number;
  fromAmount: number;
  toAmount: number;
  cells: SlabCell[];
}

// interface ProductGroup {
//   productId: number;
//   productName: string;
//   processColumns: { processId: number; processName: string }[]; // union of processes in this product
//   slabs: SlabRow[];
//   collapsed: boolean;
// }
interface ProductGroup {
  productId: number;
  productName: string;
  processColumns: { processId: number; processName: string; level: number }[]; // ADD level
  slabs: SlabRow[];
  collapsed: boolean;
}

interface BranchGroup {
  branchId: number;
  branchName: string;
  products: ProductGroup[];
  collapsed: boolean;
}

interface RightChange {
  ParentId: number;
  ProcessId: number;
  IsAllow: boolean;
}

@Component({
  selector: 'app-emp-branch-product-process-assign',
  templateUrl: './emp-branch-product-process-assign.component.html',
  styleUrls: ['./emp-branch-product-process-assign.component.scss'],
  standalone: false
})

export class EmpBranchProductProcessAssignComponent implements OnInit {
  private _MasterService;
  private data: any;
  showSpinner: boolean = false;
  RequestModel: RequestModel = new RequestModel();
  ReportingManagerRequestModel: RequestModel = new RequestModel();
  ReportingManagerDropdown: any;
  RolesDropdownData: any = [];
  SelectRoleId: any = '';
  currentUser: any;
  EmployeeList = [];
  EmployeeId: any = "0";
  EmpManagerId: any;
  EmployeeName: any;
  EmployeeDetailData: any = {};

  // @Input() employeeId!: number;

  branches: BranchGroup[] = [];
  searchTerm = '';

  // key = `${parentId}_${processId}` -> original IsAllow value from server
  private originalState = new Map<string, boolean>();

  // pending changes keyed the same way, so re-toggling back to original removes it
  private dirty = new Map<string, RightChange>();

  loading = false;
  saving = false;
  loadError = '';
  saveMessage = '';

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor( public snackBar: MatSnackBar,
    private dataSharingService: DataSharingService,
    private MasterService: MasterService,
    private dialog: DialogService,) { 
       this._MasterService = MasterService;
      this.data = JSON.parse(sessionStorage.getItem("currentUser")); 
    }

  ngOnInit(): void {
     this.dataSharingService.HeaderTitle.next("Branch Product Process Assign");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.EmployeeId = sessionStorage.getItem('getEmployeeID');
    if (this.EmployeeId != "0") {
      // this.isEdit = true;
      // this.IsCreateEmployee = false;
      this.Get_Master();
      this.getEmployeeData();
    }
    this.MasterService.GetEmployeeList(this.RequestModel).subscribe(
      (res: any) => {
        this.EmployeeList = res;
      }
    );
    this.GetEmployeeProcessRights();

  }
  Get_Master() {
    this.showSpinner = true;
    this._MasterService.GetRoleForDropdown().subscribe((result) => {
      this.RolesDropdownData = JSON.parse(JSON.stringify(result));
    });
    this._MasterService.ReportingManagerForDropdown(this.ReportingManagerRequestModel).subscribe((result) => {
      this.ReportingManagerDropdown = JSON.parse(JSON.stringify(result));
      this.showSpinner = false;
    });
  }
  getEmployeeData() {
      // this.LoanProcessList = [];
      this.RequestModel.EmpId = (this.EmployeeId);
      this._MasterService.GetEmployeeDetails(this.RequestModel).subscribe((result) => {
        //console.log("RESULT :",result);
        
        this.EmployeeDetailData = result;
        console.log("EmployeeDetailData :", this.EmployeeDetailData);
     
        this.EmployeeName = this.EmployeeDetailData.Item1[0].Emp_FirstName + ' ' + this.EmployeeDetailData.Item1[0].Emp_LastName;
        // this.LastName = this.EmployeeDetailData.Item1[0].Emp_LastName;
        this.SelectRoleId = this.EmployeeDetailData.Item1[0].Emp_RoleId;
        this.EmpManagerId = this.EmployeeDetailData.Item1[0].Emp_ManagerId;
  
        // this.LoanProcessList = this.EmployeeDetailData.Item5;
        // this.LoanProcessList.map((item) => {
        //   item.isActiveSelect = item.ProcessAlradyAssigned;
        //   item.isDisable = item.ProcessAlradyAssigned;
        // });
  
  
  
      });
    }

    GetEmployeeProcessRights() {
      // this.showSpinner = true;
      this._MasterService.Get_Employee_Process_Rights({
        LoginUserId: this.EmployeeId,
      }).subscribe({
      next: (rows) => this.buildViewModel(rows || []),
      error: () => this.loadError = 'Unable to load process rights. Please try again.'
    });
    }
    private buildViewModel(rows: ProcessRightApiRow[]): void {
    this.originalState.clear();
    this.dirty.clear();
 
    const branchMap = new Map<number, BranchGroup>();
 
    for (const row of rows) {
      // ---- Branch level ----
      let branch = branchMap.get(row.BranchId);
      if (!branch) {
        branch = {
          branchId: row.BranchId,
          branchName: row.Branch_Name,
          products: [],
          collapsed: false
        };
        branchMap.set(row.BranchId, branch);
      }
 
      // ---- Product level ----
      let product = branch.products.find(p => p.productId === row.ProductId);
      if (!product) {
        product = {
          productId: row.ProductId,
          productName: row.Product_Name,
          processColumns: [],
          slabs: [],
          collapsed: false
        };
        branch.products.push(product);
      }
 
      // register process as a column for this product, if not already present
      // if (!product.processColumns.some(c => c.processId === row.ProcessId)) {
      //   product.processColumns.push({ processId: row.ProcessId, processName: row.Process_Name });
      // }
      if (!product.processColumns.some(c => c.processId === row.ProcessId)) {
        product.processColumns.push({
          processId: row.ProcessId,
          processName: row.Process_Name,
          level: Number(row.Level)          // ADDED
        });
      }
 
      // ---- Slab (row) level ----
      let slab = product.slabs.find(s => s.parentId === row.ParentId);
      if (!slab) {
        slab = {
          parentId: row.ParentId,
          fromAmount: row.From_LoanAmount,
          toAmount: row.To_LoanAmount,
          cells: []
        };
        product.slabs.push(slab);
      }
 
      const isAllow = !!row.IsAllow;
      slab.cells.push({ processId: row.ProcessId, processName: row.Process_Name, level: Number(row.Level), isAllow });
 
      this.originalState.set(this.key(row.ParentId, row.ProcessId), isAllow);
    }
 
    // sort for stable, predictable display
    const branchesArr = Array.from(branchMap.values())
      .sort((a, b) => a.branchName.localeCompare(b.branchName));
 
    for (const b of branchesArr) {
      b.products.sort((a, b2) => a.productName.localeCompare(b2.productName));
      // for (const p of b.products) {
      //   // p.processColumns.sort((a, b2) => a.processName.localeCompare(b2.processName));
      //   p.slabs.sort((a, b2) => a.fromAmount - b2.fromAmount);
      //    for (const slab of p.slabs) {
      //     slab.cells.sort((a, b2) => a.level - b2.level);
      //   }
      // }
      for (const p of b.products) {
        p.processColumns.sort((a, b2) => a.level - b2.level);   // CHANGED: order columns by Level, not name
        p.slabs.sort((a, b2) => a.fromAmount - b2.fromAmount);
        for (const slab of p.slabs) {
          slab.cells.sort((a, b2) => a.level - b2.level);
        }
      }

    }
 
    this.branches = branchesArr;
  }
 
  private key(parentId: number, processId: number): string {
    return `${parentId}_${processId}`;
  }
 
  // Lookup helper for the template: does this slab have a value for this column?
  cellFor(slab: SlabRow, processId: number): SlabCell | undefined {
    return slab.cells.find(c => c.processId === processId);
  }
 
  // toggle(slab: SlabRow, processId: number, processName: string): void {
  //   let cell = this.cellFor(slab, processId);
 
  //   if (!cell) {
  //     // this product/process combo had no row for this particular slab — create one, default unchecked -> now checking it
  //     cell = { processId, processName, isAllow: false };
  //     slab.cells.push(cell);
  //   }
 
  //   cell.isAllow = !cell.isAllow;
 
  //   const k = this.key(slab.parentId, processId);
  //   const original = this.originalState.get(k) ?? false;
 
  //   if (cell.isAllow === original) {
  //     this.dirty.delete(k);
  //   } else {
  //     this.dirty.set(k, { ParentId: slab.parentId, ProcessId: processId, IsAllow: cell.isAllow });
  //   }
  // }
  toggle(slab: SlabRow, processId: number, processName: string, level: number): void {
  let cell = this.cellFor(slab, processId);

  if (!cell) {
    cell = { processId, processName, level, isAllow: false };   // ADDED level
    slab.cells.push(cell);
  }

  cell.isAllow = !cell.isAllow;

  const k = this.key(slab.parentId, processId);
  const original = this.originalState.get(k) ?? false;

  if (cell.isAllow === original) {
    this.dirty.delete(k);
  } else {
    this.dirty.set(k, { ParentId: slab.parentId, ProcessId: processId, IsAllow: cell.isAllow });
  }
}
 
  get hasChanges(): boolean {
    return this.dirty.size > 0;
  }
 
  get changeCount(): number {
    return this.dirty.size;
  }
 
  toggleBranch(branch: BranchGroup): void {
    branch.collapsed = !branch.collapsed;
  }
 
  toggleProduct(product: ProductGroup): void {
    product.collapsed = !product.collapsed;
  }
  expandAll(): void {
  for (const branch of this.branches) {
    branch.collapsed = false;
    for (const product of branch.products) {
      product.collapsed = false;
    }
  }
}

collapseAll(): void {
  for (const branch of this.branches) {
    branch.collapsed = true;
    // product.collapsed doesn't matter while branch is collapsed, but keep them
    // consistent so re-expanding a branch doesn't unexpectedly show open products
    for (const product of branch.products) {
      product.collapsed = true;
    }
  }
}
 
  discardChanges(): void {
    this.GetEmployeeProcessRights();
  }
 
  saveChanges(): void {
    if (!this.hasChanges || this.saving) { return; }
 
    this.saving = true;
    this.saveMessage = '';
 
    const payload = {
      EmpId: this.EmployeeId,
      ModifiedBy: this.currentUser.userId,
      json: JSON.stringify(Array.from(this.dirty.values())) 
    };
 
    // this.http.post<{ CODE: number; Msg: string }>(
    //   `${environment.apiUrl}/Update_Employee_Process_Rights`,
    //   payload
    // )
    // .pipe(finalize(() => this.saving = false))
    // .subscribe({
    //   next: (res) => {
    //     if (res && res.CODE === 0) {
    //       this.saveMessage = res.Msg || 'Rights updated successfully.';
    //       this.loadRights(); // re-fetch to get authoritative state, clears dirty map
    //     } else {
    //       this.saveMessage = res?.Msg || 'Something went wrong while saving.';
    //     }
    //   },
    //   error: () => this.saveMessage = 'Unable to save changes. Please try again.'
    // });
    this._MasterService.Update_Employee_Process_Rights(payload).subscribe({
      next: (res: any) => {
        if (res && res[0].CODE == 0) {
          // this.saveMessage = res.Msg || 'Rights updated successfully.';
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG || 'Rights updated successfully.',
            ...this.configSuccess,
          });
          this.GetEmployeeProcessRights(); // re-fetch to get authoritative state, clears dirty map
        } else {
          // this.saveMessage = res?.Msg || 'Something went wrong while saving.';
           this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG || 'Something went wrong while saving.',
            ...this.configSuccess,
          });
        }
      },
      error: () => this.saveMessage = 'Unable to save changes. Please try again.',
      complete: () => this.saving = false
    });
  }
 
  private getCurrentAdminId(): number {
    // replace with however the logged-in admin's id is retrieved in this app
    // e.g. this.authService.currentUserId
    return Number(localStorage.getItem('EmployeeId')) || 0;
  }
 
  trackByParentId(_: number, slab: SlabRow): number {
    return slab.parentId;
  }
 
  trackByProductId(_: number, product: ProductGroup): number {
    return product.productId;
  }
 
  trackByBranchId(_: number, branch: BranchGroup): number {
    return branch.branchId;
  }
  private matchesSearch(name: string): boolean {
  const term = this.searchTerm.trim().toLowerCase();
  if (!term) { return true; }
  return name.toLowerCase().includes(term);
}

// branch is visible if its own name matches, or any of its products match
branchHasVisibleContent(branch: BranchGroup): boolean {
  if (!this.searchTerm.trim()) { return true; }
  if (this.matchesSearch(branch.branchName)) { return true; }
  return branch.products.some(p => this.matchesSearch(p.productName));
}

// product is visible if the branch itself matched (show all its products),
// or the product's own name matches
productVisible(branch: BranchGroup, product: ProductGroup): boolean {
  if (!this.searchTerm.trim()) { return true; }
  if (this.matchesSearch(branch.branchName)) { return true; }
  return this.matchesSearch(product.productName);
}

// auto-expand matches while searching, without touching the real collapsed flag
isBranchExpanded(branch: BranchGroup): boolean {
  if (this.searchTerm.trim()) { return true; }
  return !branch.collapsed;
}

isProductExpanded(product: ProductGroup): boolean {
  if (this.searchTerm.trim()) { return true; }
  return !product.collapsed;
}

clearSearch(): void {
  this.searchTerm = '';
}

}
